/** Frontmatter for the "week9-waiver-wire-darkness-report" article; the Body lives in week9-waiver-wire-darkness-report.jsx. */
const meta = {
  slug: 'week9-waiver-wire-darkness-report',
  title: 'Week 9 Waiver Wire: The Darkness Report',
  category: 'Waivers',
  author: 'Andy Darkness',
  excerpt:
    'Tyler Allgeier, Chris Rodriguez Jr. and Adonai Mitchell lead a Week 9 wire shaped by Lamar Jackson\'s thumb, a Bengals-Falcons game in Madrid and a Week 8 report card where the streaming defenses paid. A FAAB ladder, the full board, a superflex corner, a D/ST streaming chart built on implied totals, an IDP board, the injury ledger, the Week 8 receipts and the bid sheet.',
  readMinutes: 15,
  date: '2026-11-03',
};

export default meta;
